<template>
  <v-flex xs12 class="px-4">
    <v-layout justify-end>
      <v-btn dark small color="error" @click="setDeletionDialog(true)">
        {{ deletionButtonMessage }}
        <v-icon small>delete</v-icon>
      </v-btn>
    </v-layout>

    <reversible-text-field
      class="title mb-2 title-description"
      :text="content.title"
      label="Título"
      textClass="headline"
      @didTapSave="updateTitle"
    />
    <reversible-text-field
      class="description title-description"
      :text="content.description || ''"
      label="Descrição"
      multiline
      @didTapSave="updateDescription"
    />
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarMessage }}
      <v-btn text @click="closeMessage">Fechar</v-btn>
    </v-snackbar>

    <default-dialog
      :value="deletionDialog"
      :title="'Exclusão'"
      color="error"
      @input="setDeletionDialog(false)"
    >
      <p class="pt-2">{{ deletionDialogMessage }}</p>
      <template slot="actions">
        <v-spacer />
        <v-btn text dark color="disabled" @click="setDeletionDialog(false)">Cancelar</v-btn>
        <v-btn
          dark
          color="error"
          @click="deleteContent"
        >Excluir</v-btn>
      </template>
    </default-dialog>
  </v-flex>
</template>

<script>
import {
  getContentByID,
  updateContent,
  deleteContent
} from "@/firebase/api/content";
import ReversibleTextField from "@/components/ReversibleTextField";
import DefaultDialog from "@/components/dialogs/Default";
import { deleteFileOnStorage } from "@/firebase/api/files";

export default {
  components: { ReversibleTextField, DefaultDialog },
  props: {
    chapterID: { required: true, type: String }
  },

  mounted() {
    this.$bind(
      "content",
      getContentByID(this.chapterID, this.$route.params.contentID)
    );
  },
  data: () => ({
    content: {},
    snackbar: false,
    deletionDialog: false,
    snackbarColor: "",
    deletionButtonMessages: {
      images: "excluir galeria",
      folder: "excluir pasta",
      pdf: "excluir pdf"
    },
    deletionDialogMessages: {
      images:
        "Você tem certeza que deseja excluir a galeria? Os conteúdos cadastrados não serão mais acessíveis.",
      folder:
        "Você tem certeza que deseja excluir a pasta? Os conteúdos cadastrados não serão mais acessíveis.",
      pdf:
        "Você tem certeza que deseja excluir o PDF? Os conteúdos cadastrados não serão mais acessíveis."
    },
    arraysType: {
      images: "images",
      folder: "files"
    },
    snackbarMessage: "",
    titleUpdateMessage: "O título foi atualizado.",
    descriptionUpdateMessage: "A descrição foi atualizada."
  }),

  computed: {
    deletionButtonMessage() {
      return this.deletionButtonMessages[this.content.type];
    },
    deletionDialogMessage() {
      return this.deletionDialogMessages[this.content.type];
    },
    contentType() {
      return this.arraysType[this.content.type];
    }
  },

  methods: {
    updateField(attributeObj) {
      updateContent(
        this.chapterID,
        this.$route.params.contentID,
        attributeObj
      ).then(() => {
        const attribute = Object.keys(attributeObj)[0];
        this.snackbarColor = "blue darken-3";
        this.snackbarMessage = this[`${attribute}UpdateMessage`];
        this.snackbar = true;
      });
    },
    updateTitle(title) {
      title = title.trim();
      this.updateField({ title });
    },
    updateDescription(description) {
      description = description.trim();
      this.updateField({ description });
    },
    closeMessage() {
      this.snackbar = false;
    },
    setDeletionDialog(state) {
      this.deletionDialog = state;
    },
    backToChapter() {
      this.$router.push(`/capitulo/${this.chapterID}`);
    },
    
    deleteContent() {
      const dataStorage = this.content.type === 'pdf' ? 'Database' : 'Storage' 
      this[`deleteContentFrom${dataStorage}`]()
    },
    deleteContentFromStorage() {
      const files = this.content[this.contentType];
      if (files) {
        const { chapterID, contentID } = this.$route.params;
        const folderPath = `chapters/${chapterID}/contents/${contentID}/content/`;
        files.forEach(file => {
          const pathFile = folderPath + file.title;
          deleteFileOnStorage(pathFile);
        });
        this.deleteContentFromDatabase();
      }
    },
    deleteContentFromDatabase() {
      this.setDeletionDialog(false);
      deleteContent(this.chapterID, this.$route.params.contentID).then(
        sucess => {
          if (sucess) this.backToChapter();
          else {
            this.snackbarColor = "error";
            this.snackbarMessage = "Erro na exclusão do conteúdo";
            this.snackbar = true;
          }
        }
      );
    }
  }
};
</script>

<style scoped>
.title-description {
  margin-top: 20px;
}
</style>